import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../@core/services/auth.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html'
})

export class RedirectComponent {
  token: string;
  trail: string;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public authService: AuthService
  ) {
    this.activatedRoute.queryParams
      .subscribe((params: Params) => {
        this.token = params.token;
        this.trail = params.trail;
        this.authenticate();
      });
  }

  authenticate() {
    sessionStorage.setItem('apiURL', environment.apiUrl);
    localStorage.setItem('apiURL', environment.apiUrl);

    const data = {
      token: this.token
    };

    this.authService.setSessionToken(data)
      .then((response) => {
          const getLanguage = (localStorage.getItem('language') || sessionStorage.getItem('language'));
          var language = (getLanguage && getLanguage != 'undefined' && getLanguage != '')? getLanguage : 'pt-br';
          console.log('LANGUAGE SET ->', language);
          this.translate.setDefaultLang(language);
          this.translate.use(language);
        this.router.navigate(['/']);
      });
  }

}
